<script lang="ts" setup>
import { ref } from "vue";
import { Checklist } from "~/api";
import { useMyInfoStore } from "~/stores/MyInfoStore";
import { showError } from "~/utils/handleAPIError";
// import { ElMessage } from "element-plus";
// import { apiClient } from "~/utils/apiClient";

const complianceChecklist = defineModel<Checklist>();
const myInfoStore = useMyInfoStore();

const emit = defineEmits(["update:modelValue"]);
const editing = ref(false);
const handleUpdateComplianceItem = async () => {
  if (!complianceChecklist.value?.guid) {
    showError("Compliance item not found");
    return;
  }
  //   await apiClient.itemDefinition
  //     .updateItemDefinition(
  //       complianceItem.value.guid,
  //       complianceItem.value,
  //     )
  //     .then(() => {
  //       editing.value = false;

  //       ElMessage.success("Compliance item updated");
  //     });
};
</script>

<template>
  <div class="compliance-item-security">
    <div v-if="myInfoStore.hasSetupBasicRole" class="edit-buttons">
      <el-button v-if="!editing" type="success" @click="editing = true">
        Edit
      </el-button>
      <div v-else>
        <el-button plain type="danger" @click="editing = false"
          >Cancel</el-button
        >
        <el-button type="success" @click="handleUpdateComplianceItem"
          >Save</el-button
        >
      </div>
    </div>

    <table>
      <tbody>
        <tr>
          <td>Security Type</td>
          <td>
            {{ "N/A" }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="less">
.compliance-item-security {
  .edit-buttons {
    grid-area: edit;
    display: flex;
    gap: 1em;
  }

  table {
    width: 100%;
    td {
      padding: 0.5em;
      border-bottom: 1px solid #ebeef5;
    }
  }
}
</style>
